import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../Components/Home/Header";
import SingleJob from "../Components/Home/SingleJob";
import { fetchJobs } from "../features/jobs/jobsSlice";
function Home() {
  const { isLoading, jobs, error } = useSelector((state) => state.jobs);
  const { searchTerm, jobType, sortBy } = useSelector((state) => state.filter);
  const [displayedJobs, setDisplayedJobs] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchJobs());
  }, [dispatch]);

  useEffect(() => {
    let filteredJobs = [...jobs];

    switch (jobType) {
      case "Full Time":
        filteredJobs = filteredJobs.filter((job) => job.type === "Full Time");
        break;
      case "Internship":
        filteredJobs = filteredJobs.filter((job) => job.type === "Internship");
        break;
      case "Remote":
        filteredJobs = filteredJobs.filter((job) => job.type === "Remote");
        break;

      default:
        break;
    }

    switch (sortBy) {
      case "Salary (Low to High)":
        filteredJobs = filteredJobs.sort((a, b) =>
          a.salary > b.salary ? 1 : -1
        );
        break;
      case "Salary (High to Low)":
        filteredJobs = filteredJobs.sort((a, b) =>
          a.salary > b.salary ? -1 : 1
        );
        break;

      default:
        break;
    }

    filteredJobs = filteredJobs?.filter((job) =>
      job.title?.includes(searchTerm)
    );

    setDisplayedJobs(filteredJobs);
  }, [searchTerm, sortBy, jobType, jobs]);

  let content = null;
  if (isLoading) content = "Loading Posts....";
  if (!isLoading && error) content = "Something went wrong..";
  if (!isLoading && !error && jobs.length === 0) content = "No Jobs Yet!";
  if (!isLoading && !error && jobs.length > 0)
    content = displayedJobs.map((job) => <SingleJob job={job} key={job.id} />);
  return (
    <main className="max-w-3xl rounded-lg  mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
      <Header />
      <div className="jobs-list">{content}</div>
    </main>
  );
}

export default Home;
